var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ipub-editor', _vm.isFocus?'ipub-editor--active':'']},[_c('textarea',{attrs:{"id":_vm.tinymceId},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }